"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMM_FEE = exports.AMM_FACTORY = exports.AMM_ROUTER_ADDRESS = exports.RPC_ENDPOINT = void 0;
exports.RPC_ENDPOINT = {
    56: 'https://nodes.pancakeswap.com/'
};
exports.AMM_ROUTER_ADDRESS = {
    56: {
        'pancake': '0x10ED43C718714eb63d5aA57B78B54704E256024E',
        'biswap': '0x3a6d8cA21D1CF76F653A67577FA0D27453350dD8'
    }
};
exports.AMM_FACTORY = {
    56: {
        position_exchange: '0x2bb7edcf50fd3870ce64f9cf559b4893da432655',
        pancake: '0xca143ce32fe78f1f7019d7d551a6402fc5350c73',
        biswap: '0x858e3312ed3a876947ea49d572a7c42de08af7ee',
        position_exchange_amm: '0xca143ce32fe78f1f7019d7d551a6402fc5350c73'
    }
};
exports.AMM_FEE = {
    56: {
        pancake: 0.25,
        biswap: 0.1,
        position_exchange: 0.2,
        position_exchange_amm: 0.25
    }
};
//# sourceMappingURL=constant.js.map